import React from 'react';

const PublicationsComponent = () => {
  return (
    <div className="sidebar-container help-sidebar">
      <p className="light-grey-text">HELP</p>
      <h1 className="title">Publications</h1>
      <p className="alt-text">If you have any published work on engineering topics, adding those here is a great way to establish yourself as a capable and reputable engineer.</p>
      <h1 className="sub-title">Example</h1>
      <div className="panel">
        <p className="sub-title">What did you build?</p>
        <ul className="categoried-list">
          <li>
            2020<br />
            Custom React hook for pagination<br/>
            https://medium.com/turingcom
          </li>
          <li>
            2017<br/>
            A Framework for Streaming Soft Real-Time Predictive and Prescriptive Analytics<br/>
            https://link.springer.com/chapter/xxxxxx
          </li>
        </ul>
      </div>
    </div>
  );
};

export default PublicationsComponent;
